import { COLORS } from './constants';

// ── Progress arc constants (based on Figma SVG, viewBox 0 0 135 135) ────────
const FIGMA_VB = 135;

// Centerline arc derived from Figma ring geometry
const ARC_CX = 67.5;
const ARC_CY = 65;
const ARC_R = 58;
const ARC_STROKE_W = 13;
const ARC_GAP_Y = 80;
const ARC_GAP_DX = Math.sqrt(ARC_R * ARC_R - (ARC_GAP_Y - ARC_CY) * (ARC_GAP_Y - ARC_CY));

// Horseshoe arc: nearly complete circle with small gap at bottom
const ARC_PATH = `M ${ARC_CX - ARC_GAP_DX},${ARC_GAP_Y} A ${ARC_R},${ARC_R} 0 1,1 ${ARC_CX + ARC_GAP_DX},${ARC_GAP_Y}`;

// Badge geometry
const BADGE_WIDTH = 90;
const SCALE = BADGE_WIDTH / 110;
const HEX_CLIP_Y = 75;
const BANNER_GAP = -2;

// Display size and positioning
const RING_DISPLAY_SIZE = 108;
const DISPLAY_SCALE = RING_DISPLAY_SIZE / FIGMA_VB;
const ENDPOINT_Y_BADGE = HEX_CLIP_Y * SCALE + BANNER_GAP - 8;
const RING_LEFT = (55 * SCALE) - ARC_CX * DISPLAY_SCALE;
const RING_TOP = ENDPOINT_Y_BADGE - ARC_GAP_Y * DISPLAY_SCALE;

const ProgressRing = ({ progress }) => {
  const offset = 100 * (1 - progress / 100);

  return (
    <svg
      width={RING_DISPLAY_SIZE}
      height={RING_DISPLAY_SIZE}
      viewBox={`0 0 ${FIGMA_VB} ${FIGMA_VB}`}
      style={{
        position: 'absolute',
        left: `${RING_LEFT}px`,
        top: `${RING_TOP}px`,
        pointerEvents: 'none',
      }}
    >
      <path
        d={ARC_PATH}
        stroke={COLORS.progressGray}
        strokeWidth={ARC_STROKE_W}
        fill="none"
        strokeLinecap="round"
      />
      {progress > 0 && (
        <path
          d={ARC_PATH}
          stroke={COLORS.progressGreen}
          strokeWidth={ARC_STROKE_W}
          fill="none"
          pathLength={100}
          strokeDasharray={100}
          strokeDashoffset={offset}
          strokeLinecap="round"
        />
      )}
    </svg>
  );
};

export default ProgressRing;
